import moment from 'moment';
import uuid from 'uuid';

import { APP_INFO } from './constants';

export const appInfo = ({
  id = uuid(),
  title = '',
  route = '#',
  when = moment()
} = {}) => {
  if (title) {
    return {
      type: APP_INFO,
      notification: {
        id,
        title,
        route,
        type: 'info',
        when,
        read: false
      }
    };
  }
};
